import React from 'react'
import { IconGreenCheck } from '../../../../assets/icons'
import { View, Text } from 'react-native'
import { commonColors } from '@linqpal/common-frontend/src/theme'

export const SuccessMessage = ({ account }) => {
  return (
    <View>
      <View style={{ flexDirection: 'row', alignItems: 'center' }}>
        <IconGreenCheck />
        <Text
          style={{
            fontWeight: '600',
            fontSize: 16,
            lineHeight: 28,
            color: commonColors.textDark,
            marginLeft: 12,
          }}
        >
          {`${
            account.paymentMethodType === 'bank' ? 'Bank Account' : 'Card'
          } linked successfully`}
        </Text>
      </View>
      <Text
        style={{
          fontWeight: '400',
          fontSize: 14,
          lineHeight: 26,
          color: commonColors.textLight,
        }}
      >
        {`Your ${
          account.paymentMethodType === 'bank' ? 'bank account' : 'card'
        } has linked to your BlueTape account.`}
      </Text>
    </View>
  )
}
